import { Repository } from 'app/services/database/repository';
import { DevicesGroupModel } from 'app/views/devices/models/devicesGroup.model';

export class DevicesGroupRepository extends Repository<DevicesGroupModel> {
    protected get path() { return '/devicesGroups/'; }
}


// WEBPACK FOOTER //
// ./src/app/services/database/devicesGroup.repository.ts